import React from 'react';
import { colors, Div, Figure } from 'globalStyle';
// import { Container, colors, Figure } from 'globalStyle';
import styled from 'styled-components';

// import Box from '@material-ui/core/Box';
import { routes } from 'routes';
import { Ghost, colorType } from 'components/Buttons';
import { Text, Title } from 'components/Texts';
import logo from 'assets/akademia-white.svg';
import casf from 'assets/casf-white.svg';
import { Box } from '@material-ui/core';
import ImageLazyLoad from 'page/components/LazyLoadingImage';

export const Desktop = () => (
  <FooterContainer>
    <Div
      style={{
        position: 'absolute',
        top: 0,
        right: 0,
        height: '99%',
        overflow: 'hidden',
      }}
    />
    <ContainerInfo>
      <Box style={{ width: '34%', height: '100%' }}>
        <Div
          isFlex
          direction="row"
          align="center"
          style={{ gap: '18px', height: '100%' }}
        >
          <Figure
            width="220px"
            height="220px"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              overflow: 'hidden',
              flexShrink: 0,
              marginLeft: '-12px',
            }}
          >
            <img
              src={logo}
              alt="logo"
              style={{
                maxWidth: '100%',
                maxHeight: '100%',
                width: 'auto',
                height: 'auto',
                objectFit: 'contain',
              }}
            />
          </Figure>
          <Text
            size={11}
            color={colors.WHITE}
            style={{ width: '28ch', lineHeight: '1.6' }}
          >
            Akademia es un simulador educativo. No actúa como entidad de
            crédito, intermediario de valores ni plataforma de inversión
            real, y no desempeña el papel de asesor financiero.
          </Text>
        </Div>
      </Box>

      <Box style={{ width: '18%' }}>
        <Title size={18} color={colors.WHITE} mb={20}>
          Explora
        </Title>

        <Div isFlex direction="column" align="start">
          <Ghost
            href={routes.aboutUs}
            onColorType={colorType.GRAY}
            color={colors.WHITE}
            style={{ 'font-size': '13px' }}
            mb={15}
          >
            Acerca de nosotros
          </Ghost>
          <Ghost
            href={routes.frequentQuestions}
            onColorType={colorType.GRAY}
            color={colors.WHITE}
            style={{ 'font-size': '13px' }}
            mb={15}
          >
            Preguntas frecuentes
          </Ghost>

          <Ghost
            href={routes.message.team}
            onColorType={colorType.GRAY}
            color={colors.WHITE}
            style={{ 'font-size': '13px' }}
            mb={15}
          >
            Empleos
          </Ghost>
          <Ghost
            href={routes.resources}
            onColorType={colorType.GRAY}
            color={colors.WHITE}
            style={{ 'font-size': '13px' }}
            mb={15}
          >
            Productos y servicios
          </Ghost>
          <Ghost
            href={routes.correspondents}
            onColorType={colorType.GRAY}
            color={colors.WHITE}
            style={{ 'font-size': '13px' }}
            mb={15}
          >
            Nuestros corresponsales
          </Ghost>
        </Div>
      </Box>
      <Box style={{ width: '16%' }}>
        <Title size={18} color={colors.WHITE} mb={20}>
          Contacto
        </Title>
        <Div isFlex direction="column" align="start">
          <Ghost
            href={routes.message.contactUs}
            onColorType={colorType.GRAY}
            color={colors.WHITE}
            style={{ 'font-size': '13px' }}
          >
            Centro de ayuda
          </Ghost>
        </Div>
      </Box>
      <Box style={{ width: '16%' }}>
        <Title size={18} color={colors.WHITE} mb={20}>
          Legal
        </Title>
        <Div isFlex direction="column" align="start">
          <Ghost
            href={routes.termsAndConditions}
            onColorType={colorType.GRAY}
            color={colors.WHITE}
            style={{ 'font-size': '13px' }}
            mb={15}
          >
            Términos de uso
          </Ghost>
          <Ghost
            href={routes.dataProcessingPolicy}
            onColorType={colorType.GRAY}
            color={colors.WHITE}
            style={{ 'font-size': '13px' }}
          >
            Política de tratamiento de datos
          </Ghost>
        </Div>
      </Box>
    </ContainerInfo>
    <Div
      isFlex
      width="100%"
      justify="space-between"
      align="center"
      style={{ height: '81px', padding: '0 60px' }}
    >
      <Div margin="0 134px 0 0">
        <Text size={10} color={colors.WHITE}>
          © 2026 Akademia, todos los derechos reservados
        </Text>
      </Div>

      <Div isFlex align="center" margin="0 80px 0 0" style={{ maxHeight: '100%' }}>
        <LogoCASF>
          <ImageLazyLoad
            src={casf}
            alt="Consejo Académico de Supervisión Financiera (CASF)"
            width="100%"
          />
        </LogoCASF>
      </Div>
    </Div>
  </FooterContainer>
);

const FooterContainer = styled.div`
  width: 100%;
  min-height: 325px;
  height: auto;
  z-index: 6;
  background: ${colors.GRAY_9};
  position: relative;
`;
const ContainerInfo = styled.div`
  border-bottom: 1px solid ${colors.WHITE};
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 40px 60px;
`;
const LogoCASF = styled.div`
  transform: rotate(0deg);
  width: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
